import { render, staticRenderFns } from "./resa.vue?vue&type=template&id=a5308928&"
import script from "./resa.vue?vue&type=script&lang=js&"
export * from "./resa.vue?vue&type=script&lang=js&"
import style0 from "./resa.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./resa.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports